
















import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import Backdrop from '@/components/Backdrop.vue';

@Component({
  components: {
    Backdrop,
  },
})
export default class LobbyCard extends Vue {
  @Prop() header: string;
  @Prop() hideBackdrop: boolean;
}
